import PropTypes from "prop-types";
import { Box } from "@mui/material";

// Round flashlight (torch) toggle.
export const TorchButton = (props) => {
  const { on, enabled, onToggle } = props;
  const bg = on ? "#fff" : "rgba(120,120,120,0.9)";
  const fg = on ? "#000" : "#fff";

  return (
    <Box
      component="button"
      type="button"
      aria-label="Toggle flashlight"
      disabled={!enabled}
      onClick={() => enabled && onToggle(!on)}
      sx={{
        position: "relative",
        width: 40,
        height: 40,
        borderRadius: "50%",
        border: "none",
        p: 0,
        backgroundColor: bg,
        opacity: enabled ? 1 : 0.5,
        cursor: enabled ? "pointer" : "default",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "background-color 0.3s",
      }}
    >
      {/* lightning-bolt icon */}
      <svg width="20" height="20" viewBox="0 0 24 24" fill={fg}>
        <path d="M7 2v11h3v9l7-12h-4l4-8z" />
      </svg>

      {/* diagonal slash when off */}
      {!on && (
        <Box
          sx={{
            position: "absolute",
            width: 26,
            height: 2,
            backgroundColor: fg,
            transform: "rotate(45deg)",
          }}
        />
      )}
    </Box>
  );
};

TorchButton.propTypes = {
  on: PropTypes.bool.isRequired,
  enabled: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
};
